<template>
  <v-container>
    <v-row justify="center" class="mb-1">
      <v-col justify-center cols="6" sm="4" md="4">
        <p class="text-left font-weight-black">
          {{ 'Aula: ' + name }}
        </p>
        <p class="text-left font-weight-black">
          {{ 'Estudiantes: ' + students }}
        </p>
      </v-col>
      <v-col class="text-right" cols="6" sm="4" md="4">
        <v-btn
          class="justify-center"
          @click="dialog = true"
          color="primary"
          fab
          small
          dark
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-row justify="center">
      <v-col justify-center cols="6" sm="6" md="4">
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="selectedDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="centered-input mt-2"
              v-model="selectedDate"
              label="Seleccione fecha"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            color="green lighten-1"
            v-model="selectedDate"
            locale="es-ES"
            :events="events"
            event-color="green lighten-1"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false">
              Cancelar
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $refs.dialog.save(selectedDate)
                loadInfoSelectedDate(selectedDate)
              "
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card class="mx-auto" max-width="600" color="#f76565">
          <v-card-text>
            <v-row class="mb" justify="center">
              <v-col justify-center>
                <v-text-field
                  dense
                  dark
                  class="centered-input v-label-white"
                  v-model.number="r"
                  label="Residuo total"
                  append-outer-icon="mdi-plus"
                  @click:append-outer="incrementR"
                  prepend-icon="mdi-minus"
                  @click:prepend="decrementR"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card class="mx-auto" max-width="600" color="#fb8c00">
          <v-card-text>
            <v-row class="mb" justify="center">
              <v-col justify-center>
                <v-text-field
                  dense
                  dark
                  class="centered-input v-label-white"
                  v-model.number="o"
                  label="Residuos reciclables"
                  append-outer-icon="mdi-plus"
                  @click:append-outer="incrementO"
                  prepend-icon="mdi-minus"
                  @click:prepend="decrementO"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card class="mx-auto" max-width="600" color="#46bd87">
          <v-card-text>
            <v-row class="mb" justify="center">
              <v-col justify-center>
                <v-text-field
                  dense
                  dark
                  class="centered-input v-label-white"
                  v-model.number="g"
                  label="Residuo cero"
                  append-outer-icon="mdi-plus"
                  @click:append-outer="incrementG"
                  prepend-icon="mdi-minus"
                  @click:prepend="decrementG"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2">
      <v-col class="text-center" cols="6" sm="6" md="4">
        <v-btn
          class="justify-center"
          :disabled="!validCount"
          @click="addNewDate"
          color="green"
          dark
        >
          Guardar
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="submit">
          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Editar aula</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                    dark
                    text
                    type="submit"
                    @click="updateClassroom"
                    :disabled="invalid"
                  >
                    Actualizar
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-list three-line subheader>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Nombre</v-list-item-title>
                    <ValidationProvider
                      name="nombre"
                      rules="required|max:12"
                      v-slot="{ errors }"
                      vid="nombre"
                    >
                      <v-text-field
                        required
                        id="nombre"
                        name="nombre"
                        type="nombre"
                        label="Nombre del aula"
                        :error="errors.length > 0"
                        :error-messages="errors[0]"
                        autocomplete="off"
                        v-model="name"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Numero de alumnos</v-list-item-title>
                    <ValidationProvider
                      name="alumnos"
                      rules="required|numeric|min_value:1|max_value:60"
                      v-slot="{ errors }"
                      vid="alumnos"
                    >
                      <v-text-field
                        id="alumnos"
                        name="alumnos"
                        type="alumnos"
                        label="Numero de alumnos"
                        v-model="students"
                        :error="errors.length > 0"
                        :error-messages="errors[0]"
                        autocomplete="off"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Nivel Educativo</v-list-item-title>
                    <v-select
                      v-model="select"
                      :hint="`${select.state}`"
                      :items="educationLevels"
                      item-text="state"
                      item-value="abbr"
                      label="Seleccione"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Curso</v-list-item-title>
                    <v-select
                      v-model="selectCurso"
                      :hint="`${selectCurso}`"
                      :items="cursos"
                      label="Seleccione"
                      persistent-hint
                      return-object
                      single-line
                    ></v-select>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
              <v-divider></v-divider>
              <v-row justify="center" class="mt-5">
                <v-col class="text-center" cols="6" sm="4" md="4">
                  <v-btn
                    class="justify-center"
                    @click="deleteConfirmation"
                    color="red"
                    dark
                  >
                    Eliminar aula
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
        </form>
      </ValidationObserver>
    </v-row>
    <CustomDialog ref="confirmationDialog"></CustomDialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackBarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="green" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from 'moment'
import CustomDialog from '@/components/common/CustomDialog'
import { mapState } from 'vuex'
import { isNil } from 'lodash'

export default {
  components: {
    CustomDialog
  },
  created() {
    const { id } = this.$route.params
    console.log(`Module created`)
    console.log(`/classroom/${id}`)

    // 1. Passing it as a parameter to openDBChannel
    this.$store.dispatch('dates/closeDBChannel', { clearModule: true }, { root: true })

    this.$store.dispatch('dates/openDBChannel', {
      pathVariables: { classroomId: `${id}` }
    })

    /*

    // https://apexcharts.com/vue-chart-demos/area-charts/spline/
    
    // 2. Passing it as a parameter to fetchAndAdd
    this.$store.dispatch('dates/fetchById', `${dateTime}`, {
      pathVariables: { classroomId: `${id}` }
    })
    // 3. Dispatching setPathVars
    /*
    this.$store.dispatch('dates/fetchAndAdd', {
      classroomId: `${id}`,
      dateId: `${dateTime}`
    })
    this.$store.dispatch('dates/openDBChannel', {
      pathVariables: { classroomId: `${id}` }
    })

    this.$store.dispatch('dates/set', { id: `${dateTime}` })
    */

    const currentClassroom = this.$store.state.classrooms.classrooms[id]

    console.log(currentClassroom)

    this.id = currentClassroom.id
    this.name = currentClassroom.name
    this.students = currentClassroom.students

    if(!(currentClassroom.course === undefined)){
      this.selectCurso = currentClassroom.course
    }
    if(!(currentClassroom.schoolLevel === undefined)){
      this.select = currentClassroom.schoolLevel
    }

    /*
    this.$store.dispatch('dates/fetchById', `${dateTime}`, {
      pathVariables: { classroomId: `${id}` }
    })
    */
  },
  data: () => ({
    dialog: false,
    students: null,
    name: null,
    selectedDate: new Date().toISOString().substr(0, 10),
    modal: false,
    dateTime: new Date(),
    r: 0,
    o: 0,
    g: 0,
    timeout: 2000,
    snackBarText: null,
    snackbar: false,
    educationLevels :  [
          { state: 'Educación Infantil', abbr: 'EI' },
          { state: 'Eduación Primaria', abbr: 'EP' },
          { state: 'Eduación Secundaria', abbr: 'ESO' },
          { state: 'Bachillerato', abbr: 'BACH' },
          { state: 'Formación Profesional', abbr: 'FP' },
          { state: 'Otro', abbr: 'O' },
        ],
    cursos :  [1,2,3,4,5,6,7,8,9,10],
    select: { state: 'Eduación Primaria', abbr: 'EP' },
    selectCurso: 1,
  }),

  props: {
    id: String
  },
  computed: {
    ...mapState('dates', ['dates']),
    maxValueSlider() {
      return this.students - this.r - this.o - this.g
    },
    animationDuration() {
      return `${60 / this.bpm}s`
    },
    events() {
      const ids = Object.keys(this.dates)
      console.log(ids)
      const events = ids.map(dateString => {
        const d = new Date(dateString)
        console.log(d)
        return d.toISOString().substr(0, 10)
      })
      return events
    },
    validCount() {
      return this.g + this.o + this.r <= this.students
    }
  },

  methods: {
    loadInfoSelectedDate(selectedDate) {
      const format = 'YYYY-MM-DD'
      const dateTime = moment(selectedDate).format(format)
      const currentDate = this.dates[dateTime]

      if (!isNil(currentDate)) {
        this.r = currentDate.r
        this.o = currentDate.o
        this.g = currentDate.g
      }else{
        this.r = 0
        this.o = 0
        this.g = 0
      }
    },
    async addNewDate() {
      const format = 'YYYY-MM-DD'
      const dateTime = moment(this.selectedDate).format(format)
      /*
      this.$store.dispatch('dates/fetchById', `${this.dateTime}`, {
        pathVariables: { classroomId: `${id}` }
      })
      */
      const newDoc = { id: `${dateTime}`, g: this.g, r: this.r, o: this.o }
      const done = await this.$store.dispatch('dates/insert', newDoc, {
        pathVariables: { classroomId: `${this.id}` }
      })

      console.log(done)
      this.snackBarText = 'Registro insertado con exito'
      this.snackbar = true
    },
    decrementR() {
      if (this.r > 0){
        this.r = this.r - 1
      }
    },
    incrementR() {
      this.r = this.r + 1
    },
    decrementO() {
      if (this.o > 0){
        this.o = this.o - 1
      }
    },
    incrementO() {
      this.o = this.o + 1
    },
    decrementG() {
      if (this.g > 0){
        this.g = this.g - 1
      }
    },
    incrementG() {
      this.g = this.g + 1
    },
    updateClassroom() {
      const item = {
        id: this.id,
        name: this.name,
        students: this.students,
        schoolLevel: this.select,
        course: this.selectCurso
      }
      this.$store.dispatch('classrooms/set', item)
      this.dialog = false
    },
    deleteConfirmation() {
      this.$refs.confirmationDialog.show(
        'warning',
        `¿Está seguro que desea eliminar el aula '${this.name}'?`,
        true,
        this.deteleClassroom
      )
    },
    async myFunction() {
      console.log(this.id)

      // Delete all dates
      const ids = Object.keys(this.dates)
      const a = await this.$store.dispatch('dates/deleteBatch', ids)
      console.log(a)

      this.$store.dispatch('classrooms/delete', this.id).catch(error => {
        console.error(error)
        this.errorDialog(
          'Se ha producido un error al eliminar un elemento en la base de datos.'
        )
      })
      this.$router.push('/classrooms')
      this.dialog = false
    },
    deteleClassroom() {
      return new Promise(resolve => {
        resolve()
        this.myFunction()
      })
    }
  },
  beforeDestroy() {
    console.log(`ModuleUnmount`)
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.centered-input >>> label {
  text-align: center;
}

.v-toolbar__title {
  font-size: 0.9rem !important;
}

.v-label-white {
  font-weight: bolder;
  font-size: 1.2rem !important;
}
.v-label-white >>> label {
  font-weight: bolder;
  font-size: 1.2rem !important;
}
</style>
